export default {
    watch:
        $route: (to, from) ->
            @fields = @defaultFields()
            @getContent to.params.uid

    metaInfo: ->
        title: @$prismic.richTextAsPlain @fields.meta_title
        meta: [
            name: 'description',
            vmid: 'description',
            content: @$prismic.richTextAsPlain @fields.meta_description
        ]

    methods:
        updateScripts: ->
            $('#prismic-script').remove()
            $('#gtag, #ga-script').remove()
            #$('head').append "<script id='prismic-script' src='https://static.cdn.prismic.io/prismic.min.js'>"
            $('head').append """
                <script id="ga-script" async src="https://www.googletagmanager.com/gtag/js?id=UA-182269745-1"></script>
                <script id="gtag">
                    (function (i, s, o, g, r, a, m) {
                        i['GoogleAnalyticsObject'] = r; i[r] = i[r] || function () {
                            (i[r].q = i[r].q || []).push(arguments)
                        }, i[r].l = 1 * new Date(); a = s.createElement(o),
                            m = s.getElementsByTagName(o)[0]; a.async = 1; a.src = g; m.parentNode.insertBefore(a, m)
                    })(window, document, 'script', 'https://www.google-analytics.com/analytics.js', 'ga');

                    ga('create', 'UA-182269745-1', {
                        storage: 'none'
                    });
                    var page = document.location.pathname;
                    ga('set', 'page', page || '/');
                    ga('set', 'anonymizeIp', true);
                    ga('send', 'pageview');
                </script>
            """
}